import { isly } from "isly";
import { DateTime } from "../DateTime";
export var TimeRange;
(function (TimeRange) {
    var _a;
    _a = isly
        .object({ start: DateTime.type, end: DateTime.type }, "isoly.TimeRange")
        .bind(), TimeRange.type = _a.type, TimeRange.is = _a.is, TimeRange.flawed = _a.flawed;
    function create(start, end) {
        return !DateTime.is(end)
            ? create(start, DateTime.next(start, end))
            : start <= end
                ? { start, end }
                : { start: end, end: start };
    }
    TimeRange.create = create;
})(TimeRange || (TimeRange = {}));
//# sourceMappingURL=index.js.map